import { restClient } from '../client';
import { PublicAppointment } from './user';


export const getMatchAppointmentStats = async (matchId: string) => {
  return await restClient.request<{
    data: {
      lastAppointment: PublicAppointment;
      nextAppointment: PublicAppointment;
    };
  }>(`/api/v1/match/${matchId}/stats`);
};
